import {DatePicker, Input as AntdInput, InputNumber, Radio, Select, Switch, Cascader} from "../../../../__snowpack__/pkg/antd.js";
import moment from "../../../../__snowpack__/pkg/moment.js";
import CheckboxGroup from "./CheckboxGroup.js";
import DebounceInput from "./DebounceInput.js";
import DebounceInputNumber from "./DebounceInputNumber.js";
import TagsInput from "./TagsInput.js";
import BatchFilterInput from "./BatchFilterInput/index.js";
import {Text} from "./Text.js";
import {isObject} from "../../../../__snowpack__/pkg/lodash.js";
import NumberIntervalInput from "./NumberIntervalInput/index.js";
import {Paragraph} from "./Paragraph.js";
import Input from "./Input.js";
const prefabs = {
  Cascader: {
    component: Cascader
  },
  CheckboxGroup: {
    component: CheckboxGroup
  },
  Hidden: {
    component: AntdInput,
    fieldProps: {
      hidden: true,
      componentProps: {
        hidden: true
      }
    }
  },
  Text: {
    component: Text
  },
  Paragraph: {
    component: Paragraph,
    fieldProps: {
      componentProps: {
        style: {margin: 0}
      }
    }
  },
  Input: {
    component: Input
  },
  InputGroup: {
    component: AntdInput.Group,
    fieldProps: {
      componentProps: {
        compact: true
      }
    }
  },
  BatchFilterInput: {
    component: BatchFilterInput
  },
  NumberIntervalInput: {
    component: NumberIntervalInput
  },
  TagsInput: {
    component: TagsInput,
    fieldProps: {
      componentProps: {
        style: {minWidth: 160},
        allowClear: true
      }
    }
  },
  Switch: {
    component: Switch,
    fieldProps: {
      valuePropName: "checked"
    }
  },
  DebounceInput: {
    component: DebounceInput
  },
  DebounceInputNumber: {
    component: DebounceInputNumber,
    fieldProps: {
      componentProps: {
        maxLength: 16
      }
    }
  },
  InputNumber: {
    component: InputNumber,
    fieldProps: {
      componentProps: {
        maxLength: 16
      }
    }
  },
  TextArea: {
    component: AntdInput.TextArea
  },
  RadioGroup: {
    component: Radio.Group
  },
  Select: {
    component: Select,
    fieldProps: {
      componentProps: {
        style: {
          minWidth: 160
        }
      }
    }
  },
  MultiSelect: {
    component: Select,
    fieldProps: {
      componentProps: {
        style: {
          minWidth: 160
        },
        mode: "multiple",
        allowClear: true,
        showArrow: true
      }
    }
  },
  DateRangePicker: {
    component: DatePicker.RangePicker,
    fieldProps: (formItemProps) => {
      const showTime = formItemProps?.componentProps?.showTime;
      if (!!showTime) {
        return {
          componentProps: {
            format: "DD-MM-YYYY HH:mm:ss"
          },
          rewriteComponentProps: {
            showTime: {
              defaultValue: [moment().startOf("d"), moment().endOf("d")],
              ...isObject(showTime) ? showTime : {}
            }
          }
        };
      }
      return {
        componentProps: {
          format: "DD-MM-YYYY"
        },
        getValueFromEvent: (momentInstances) => {
          const [start, end] = momentInstances ?? [];
          if (!start && !end) {
            return void 0;
          }
          return [start?.startOf("d"), end?.endOf("d")];
        }
      };
    }
  },
  DateRangePickerWithTime: {
    component: DatePicker.RangePicker,
    fieldProps: {
      componentProps: {
        showTime: {
          defaultValue: [moment().startOf("d"), moment().endOf("d")]
        }
      }
    }
  },
  DatePicker: {
    component: DatePicker,
    fieldProps: {
      componentProps: {
        format: "DD-MM-YYYY"
      }
    }
  }
};
export default prefabs;
